import { render } from "./CardCampaignList.vue?vue&type=template&id=e891927a"
import script from "./CardCampaignList.vue?vue&type=script&lang=js"
export * from "./CardCampaignList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__